import { HttpClient } from "../httpClient";
import BillingType from "../models/billingType";
import { DataResponse } from "../responses/baseResponse";

const httpClient = new HttpClient();

export const getBillingTypes = async () => {
    return httpClient.get<DataResponse<BillingType[]>>({
        url: '/v1/billingtypes',
        requiresToken: true
    });
}